import React from 'react';
import { Modal, Table, Button, Spinner, Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { convertToLocalTime } from '../Backend/BackgroundTasks/convertutclocal';

function formatDateTime(value, t) {
    if (!value) return t('N/A');
    return String(convertToLocalTime(value));
}

/**
 * TicketHistoryModal
 *
 * Props:
 *   show                {boolean}
 *   ticketId            {string|number}
 *   history             {object[]}
 *   hasMore             {boolean}
 *   isLoading           {boolean}
 *   isLoadingMore       {boolean}
 *   error               {Error|null}
 *   onLoadMore          {() => void}
 *   onClose             {() => void}
 */
export function TicketHistoryModal({
    show,
    ticketId,
    history,
    hasMore,
    isLoading,
    isLoadingMore,
    error,
    onLoadMore,
    onClose,
}) {
    const { t } = useTranslation();

    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    {t('Ticket History')} - {ticketId || t('N/A')}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {isLoading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" />
                        <div className="mt-2">{t('Loading ticket history...')}</div>
                    </div>
                ) : error ? (
                    <Alert variant="danger">{t('Unable to load ticket history')}</Alert>
                ) : (
                    <>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>{t('Date')}</th>
                                    <th>{t('Type')}</th>
                                    <th>{t('Message')}</th>
                                    <th>{t('Employee')}</th>
                                    <th>{t('Success')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {history.length > 0 ? (
                                    history.map((entry, index) => (
                                        <tr key={entry.id || index}>
                                            <td>{formatDateTime(entry.logDate, t)}</td>
                                            <td>{entry.logType || t('N/A')}</td>
                                            <td>{entry.logMessage || t('N/A')}</td>
                                            <td>{entry.employeeName || t('N/A')}</td>
                                            <td>{entry.success ? t('Yes') : t('No')}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5} className="text-center">
                                            {t('No ticket history found')}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>

                        {hasMore && history.length > 0 && (
                            <div className="d-flex justify-content-center mt-2">
                                <Button
                                    variant="primary"
                                    onClick={onLoadMore}
                                    disabled={isLoadingMore}
                                >
                                    {isLoadingMore ? t('Loading...') : t('Load More')}
                                </Button>
                            </div>
                        )}
                    </>
                )}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    {t('Close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
